import { Component, OnInit, Input } from '@angular/core';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { DatatableConfigurationMapperService } from '../../../analytics-core/services/datatable-configuration.mapper.service';
import { EVENT_EMITTERS, PATHS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { R10DevicesComponent } from '../r10-devices/r10-devices.component';
import * as _ from 'underscore';
import * as numeral from 'numeral';

@Component({
	selector: 'app-r7-sem-conversions',
	templateUrl: './r7-sem-conversions.component.html',
	styleUrls: ['./r7-sem-conversions.css']
})
export class R7SemConversionsComponent extends R10DevicesComponent implements OnInit {
	@Input() metricsarray: any;
	@Input() downloadcsvcolumns: any;
	@Input() downloadconfig: string;
	public metricsArray = [];
	public totalsArray = [];
	public metricObject;
	public downloadConfiguration: DownloadConfig;
	public downloadCSVColumns: any;
	responseData: any;
	groupByData: any;
	currentMetricTotal: any;
	public downloadIcon: string = '../../../../../assets/images/Download_Icon_R7.svg';
	public categories: any;
	public tooltipOptions = {
		position: 'top',
		animation: 'fade',
		arrowSize: 'small',
		distance: 0,
		offset: 0,
		arrow: true,
		size: 'small',
		duration: 750,
		scale: 'small',
		dynamicTitle: true,
		 theme: 'r7-sem-conversions'
	};

	constructor(
		protected analyticsDataModel: AnalyticsDataModel,
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected dataTableService: DatatableConfigurationMapperService
	) {
		super(analyticsDataModel, analyticsService, colorUtilityService, dataTableService);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadCSVColumns = JSON.parse(decodeURI(this.downloadcsvcolumns));
		this.metricsArray = JSON.parse(decodeURI(this.metricsarray));
		if (this.metricsArray) {
			this.metricsArray = _.filter(this.metricsArray, (item) => {
				return this.analyticsDataModel.checkComponentForPermission(item);
			});
		}
		this.downloadIcon = this.analyticsDataModel.config.downloadIcon
			? this.analyticsDataModel.config.downloadIcon
			: this.downloadIcon;
	}

	processDeviceColor(responseData: any): void {
		const colorArray = [
			this.colorPalette.primaryColor,
			this.colorPalette.secondaryColor,
			this.colorPalette.tertiaryColor,
			this.colorPalette.quaternaryColor,
			'#a8a8a8'
		];
		for (let j = 0; j < this.multichartconfigurations.length; ++j) {
			this.multichartconfigurations[j].chartConfig.series[0].colors = colorArray
				.slice(0, responseData.length)
				.reverse();
		}
		this.deviceCount = 'device-' + responseData.length;
	}

	processResponseData(responseData: any): void {
		this.processDeviceColor(responseData);
		for (const metric of this.metricsArray) {
			if (metric) {
				const sum_conversions = responseData.reduce((s, f) => s + Number(f[metric.valueKey]), 0);
				const all_conv_sum = responseData.reduce((s, f) => s + Number(f['all_conversions']), 0);
				this.totalsArray['conversions'] = sum_conversions;
				this.totalsArray['all_conversions'] = all_conv_sum;
				this.totalsArray['conversion_rate'] = ((sum_conversions / parseInt(responseData[0].clicks)) * 100).toFixed(2);
			}
		}
		
		this.metricObject = [
			{
				name: 'Conversions',
				value: this.totalsArray['conversions'].toLocaleString(),
				tooltip:
					'An action that’s counted when someone interacts with your ad or free product listing, then takes an action you’ve defined as valuable to your business, such as a purchase or a phone call.'
			},
			{
				name: 'Conversion Rate',
				value: this.totalsArray['conversion_rate'] + '%',
				tooltip: 'The average number of conversions per ad interaction, as a percentage.'
			},
			{
				name: 'All Conversions',
				value: this.totalsArray['all_conversions'].toLocaleString(),
				tooltip:
					'A calculation of all the conversions that Google Ads drives for your business, including any actions being excluded from your tracking metrics.'
			}
		];
		
		this.currentMetricTotal = responseData.reduce((s, f) => {
			return s + Number(f['conversions']);
		}, 0);
		responseData = this.conversionsDataProcess(responseData);
		this.devicesChartData = responseData;
	}

	conversionsDataProcess(responseData: any) {
		this.categories = [];
		if (responseData?.length <= 5) {
			responseData = responseData;
		} else {
			let tempAllConversions = 0;
			let tempConversions = 0;
			let tempclicks = 0;

			for (let i = 4; i < responseData?.length; i++) {
				tempAllConversions += Number(responseData[i]['all_conversions']);
				tempConversions += Number(responseData[i]['conversions']);
				tempclicks = Number(responseData[i]['clicks']);
			}
			let tempDataArray = {
				all_conversions: tempAllConversions.toString(),
				conversion_action: 'Additional',
				conversions: tempConversions.toString(),
				clicks: tempclicks.toString(),
				tooltip: 'All other conversion actions.'
			};
			let updatedRespData = responseData.splice(0, 4);
			updatedRespData.splice(4, 0, tempDataArray);
			responseData = updatedRespData;
			this.responseData = responseData;
		}

		this.groupByData = responseData.filter((obj) => {
			return obj['conversions'] != 0 || obj['all_conversions'] != 0;
		});

		for (let i = 0; i < this.groupByData.length; i++) {
			this.groupByData[i].conversionCompletePerc = ((Number(this.groupByData[i].conversions) / this.currentMetricTotal) * 100).toFixed(2);
			this.groupByData[i].conversion100 = 100;
			this.groupByData[i].conversions =  Number(this.groupByData[i].conversions).toLocaleString();
		}
		this.groupByData.reverse();
		this.multichartconfigurations[0].chartConfig.xAxis[0].labels.formatter =
			this.getXaxisToolTipFormatter(this.groupByData);
		

		this.multichartconfigurations[0].chartConfig.chart.height = this.groupByData.length * 120;
	
		return this.groupByData;
	}

	downloadCSV(): void {
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName
		);
	}
	
	getXaxisToolTipFormatter(data): any {
		return function (): string {
			let index = this.axis.categories.indexOf(this.value);
			let text = data[index].tooltip
				? `<div class="sem-tooltip">
        <div>${data[index].tooltip}</div>
				<div class="sem-arrow"></div>
			</div>`
						: `<div class="conversion-no-tooltip">
			<div class="sem-arrow"></div>
		</div>`;
			let conversion_perc = data[index].conversionCompletePerc + "%";
			let conversionsTotal = data[index].conversions + " Conversions";
			return (
				`<div aria-label="${data[index].tooltip}" class="sem-legend" >
                    <div class="sem-legendname">${this.value}</div>` +
				text +
				`</div>
				<div class="sem-bar-metrics"><span class="sem-conversions-perc">${conversion_perc}</span>
					<span class="sem-conversions-count">${conversionsTotal}</span></div>`
			);
		};
	}

}
